import * as React from 'react';
import { useEffect } from 'react';

export interface useOnClickOutsideParams {
  refs: React.RefObject<any>[];
  handler: (event: MouseEvent) => any;
}

export function useOnClickOutside(params: useOnClickOutsideParams) {
  const { refs, handler } = params;
  useEffect(
    () => {
      const listener = (event: MouseEvent) => {
        // Do nothing if clicking refs element or descendent elements
        if (refs.filter(ref => !!ref.current).some(ref => ref.current.contains(event.target))) {
          return;
        }

        handler(event);
      };

      document.addEventListener('mousedown', listener);

      return () => {
        document.removeEventListener('mousedown', listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in c before ...
    // ... passing it into this hook.
    [refs, handler]
  );
}
